import React from 'react';
import { Button, SvgIcon } from '@gik/ui';
import { openShareInkindModal } from '@gik/inkind-page';
import commonTranslationKeys from '@gik/i18n/en/common';
import { useTranslation } from 'react-i18next';
import bemBlock from '@gik/core/utils/bemBlock';
import { useUserStore } from '@gik/core/store/UserStore';
import { useInkind } from '@gik/api/inkinds/inkind';
import { inkindPageTourSelectors } from '@gik/inkind-page/components/InkindPageTour/InkindPageTour';

interface ShareInkindButtonProps {
  inkindRouteId: string;
}

export default function ShareInkindButton({ inkindRouteId }: ShareInkindButtonProps): JSX.Element {
  const userStore = useUserStore();
  const userId = userStore.id;
  const { t } = useTranslation();
  const { data: inkindPage } = useInkind(inkindRouteId);
  const bem = bemBlock('share-inkind-button');

  return (
    <Button
      id={inkindPageTourSelectors.shareButton}
      className={bem()}
      block
      size="lg"
      prepend={<SvgIcon set="gik-icons" name="ShareAlt" size="xl" />}
      onClick={() =>
        openShareInkindModal(
          {
            isOrganizer: inkindPage.organizers.findIndex(o => o.userId === userId) >= 0,
            pageTitle: inkindPage.title,
            pageShortUrl: inkindPage.shortUrl,
          },
          'inkindPage',
          inkindPage.url
        )
      }
    >
      {t(commonTranslationKeys.common.share)}
    </Button>
  );
}
